import Spline from "@splinetool/react-spline";
import styled from "styled-components";

import Favicon from "./images/favicon-32x32.png";
import IconCart from "./images/icon-cart.svg";
import IconMobileProduct from "./images/image-product-mobile.jpg";

export default function App() {
  return (
    <Wrapper>
      <Content>
      
        <Spline
          className="spline"
          scene="https://prod.spline.design/xkBxMNWoObmDNqpx/scene.splinecode"
        />
        <li>
          <img src={Favicon} alt="Favicon" />
        </li>
        <h1> Gabrielle Essence Eau De Parfum </h1>
        <h2> P E R F U M E </h2>
        <h3>
          {" "}
          A floral, solar and voluptuous interpretation composed by Olivier
          Polge, Perfumer-Creator for the House of CHANEL.
        </h3>
        <h4>$149.99</h4>
        <h5>
          <strike> $169.99 </strike>
        </h5>
        <button>
          <img src={IconCart} alt="IconCart" /> Add To Cart {""}
        </button>
      </Content>

      <MenuPhone>
        <h6>
          <img src={IconMobileProduct} alt="IconMobileProduct" />
        </h6>
      </MenuPhone>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  .spline {
    position: center;
    margin: 0;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    overflow-y: hidden;
    overflow-x: hidden;

    @media (max-width: 375px) {
      visibility: hidden;
    }
  }
`;

const Content = styled.ul`


     
  h1 {
    font-family: "Fraunces";
    font-weight: 700;
    font-size: 35px;
    margin: 0;
    max-width: 250px;
    color: hsl(212, 21%, 14%);

    position: absolute;

    left: 1060px;
    top: 320px;

    @media (max-width: 375px){
      max-width: 150px;
      transform: scale(0.8) translateY(-50px) translateX(-17px);
    }
    }
 
  }

  h2 {
    font-family: "Montserrat";
    font-weight: 500;
    color: hsl(228, 12%, 48%);
    font-size: 25px;
    margin: 0;
    gap: 10px;
    position: absolute;
    left: 1060px;
    top: 260px;

    @media (max-width: 375px){
      max-width: 1000px;
      font-size: 10px;
      transform: scale(0.8) translateY(5000px) translateX(100);
      transform-origin: top;
      right: auto;
      position: relative;
      flex-direction: align;

    }
  }

  h3 {
    font-family: "Montserrat";
    font-weight: 500;
    font-size: 15px;
    position: absolute;
    align-content: center;
    max-width: 250px;
    left: 1060px;
    top: 450px;
    color: hsl(228, 12%, 48%);
  }

  li {
    bottom: 1040px;
    right: -30px;
    position: relative;
    list-style: none;
  }

  h4 {
    font-family: "Fraunces";
    font-size: 43px;
    position: absolute;
    left: 1060px;
    top: 535px;
    color: hsl(158, 36%, 37%);
  }

  h5 {
    font-family: "Fraunces";
    font-size: 17px;
    position: absolute;
    left: 1250px;
    top: 582px;
    color: hsl(228, 12%, 48%);
  }

  button {
    font-family: "Montserrat";
    color: white;
    font-size: 15px;
    font-display: flex;

    padding: 12px 30px;
    border-radius: 14px;
    display: flex;
    margin: 0;
    gap: 12px;
    justify-content: center;
    align-items: center;
    width: auto;
    background: hsl(158, 36%, 37%);
    border: 1px solid hsl(158, 36%, 37%);
    position: absolute;
    left: 1050px;
    top: 680px;
    transition: 0.5s;
    width: 300px;
    height: 60px;

    :hover {
      background: hsl(158, 36%, 27%);
      border: 1px solid hsl(158, 36%, 27%);
    }

    @media (max-width: 375px){

    }
  

  
`;

const MenuPhone = styled.div`
  h6 {
    visibility: hidden;

    @media (max-width: 375px) {
      visibility: visible;
      transform: translateY(-1900px) scale(0.4) translateX(-500px);
      border-radius: 11px;
      padding: 12px;
      display: flex;
      position: absolute;
    }
  }
`;
